import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { getLoggedInUser } from '~/store/reducers/account/selector';

export const useThousandFormatter = () => {
  const currentUser = useSelector(getLoggedInUser);

  const separator = currentUser?.data?.thousandsSeparator;
  return useCallback(
    (value: number | string) => {
      const number = Number(value);

      if (isNaN(number)) return value;

      const regex = /\B(?=(\d{3})+(?!\d))/g;
      return number.toString().replace(regex, separator || '.');
    },
    [separator],
  );
};
